import { c as _c } from "react/compiler-runtime";
import { useRouter as useNextCompatRouter } from 'next/compat/router';
import { usePathname as useNextPathname, useParams, useSearchParams } from 'next/navigation';
import { isNilOrEmpty } from 'shared/utils';
export const usePathname = () => {
  const $ = _c(7);
  const pathname = useNextPathname() ?? "";
  const searchParams = useSearchParams() ?? new URLSearchParams();
  const router = useNextCompatRouter();
  let t0;
  if ($[0] !== pathname || $[1] !== searchParams) {
    t0 = !isNilOrEmpty(searchParams) ? `${pathname}?${searchParams.toString()}` : pathname;
    $[0] = pathname;
    $[1] = searchParams;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const pathnameWithQueryParams = t0;
  const t1 = router?.route ?? pathname;
  let t2;
  if ($[3] !== pathname || $[4] !== pathnameWithQueryParams || $[5] !== t1) {
    t2 = {
      pathname,
      pathnameWithQueryParams,
      route: t1
    };
    $[3] = pathname;
    $[4] = pathnameWithQueryParams;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export const useRouteParams = () => {
  const $ = _c(2);
  const params = useParams();
  let t0;
  if ($[0] !== params) {
    t0 = {
      ...params
    };
    $[0] = params;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};